<template>
  <div class="cancel_box">
    <p v-if="label" class="cancel_box--label">{{ label }}</p>
    <p v-if="heading" class="cancel_box--heading">{{ heading }}</p>

    <div class="mt-50">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelBox",
  props: {
    label: String,
    heading: String,
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.cancel_box {
  padding: 1rem;
  background-color: $background;

  &--label {
    margin-bottom: 4px;
    font-size: 0.875rem;
  }

  &--heading {
    font-size: 1.25rem;
    font-weight: bold;
  }
}
</style>
